import { clear } from '../../../../helpers/compact';
import { PostmenSliceType } from '../../../../types/slice';
import { valueLabelDesc } from './valueLabelDesc';

const getStaff = valueLabelDesc('staff');
const getJob = valueLabelDesc('job');

export const staffIllustrationSlice = ({ primary }) => {
  const staff = getStaff(primary);
  const job = getJob(primary);

  if (staff && job) {
    return clear({
      type: PostmenSliceType.STAFF_ILLUSTRATION,
      staff,
      job,
    });
  }
};
